import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import PosInvoiceCheckout from '../pos-invoice-checkout/pos-invoice-checkout.vue';
import PosToolsCheckout from '../pos-tools-checkout/pos-tools-checkout.vue';
import PosArticlesCheckout from '../pos-articles-checkout/pos-articles-checkout.vue';

@Component({
  name: 'bpc-pos-checkout',
  components: {
    'font-awesome-icon': FontAwesomeIcon,
    'pos-invoice-checkout': PosInvoiceCheckout,
    'pos-tools-checkout': PosToolsCheckout,
    'pos-articles-checkout': PosArticlesCheckout,
  },
})
export default class PosCheckout extends Vue {
  /**
   * SLOTS
   * top-left-buttons
   * top-right-buttons
   */

  onClickClose(): void {
    this.$store.commit('pos/closeDrawer');
  }

  get showDrawer(): boolean {
    return this.$store.getters['pos/showDrawer'];
  }
}
